import { StoplightProject } from "@stoplight/elements-dev-portal";
import "@stoplight/elements-dev-portal/styles.min.css";
import "./Buscativos.css"

function Buscativos() {
  return (
    <div className="container">
      <StoplightProject projectId="cHJqOjI2NTI1Ng" router="hash" />
    </div>
  );
}

export default Buscativos;
